import React from "react";
import styles from "./SetPasswordModal.module.css";
import { Button,  Typography } from "antd";
import { IconClose } from "../../../icons/IconClose";
import { useDispatch, useSelector } from "react-redux";
import PreloaderNew from "../PreloaderNew/PreloaderNew";
import { logout, setPassword } from "../../../store/auth";
import { getError } from "../../../store/auth/selectors";
import { IconSuccess } from "../../../icons/IconSuccess";
import { useNavigate } from "react-router-dom";


const { Title, Text } = Typography;


function SetPasswordSuccess() {

	const dispatch = useDispatch();

	return (
		<>
			<div
				style={{
					padding: "80px 64px",
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					position: "relative",
					alignItems: 'center',
					alignSelf: 'center',
					gap: '24px'

				}}
			>
				<IconSuccess />
				<Text style={{ margin: 0, textAlign: 'center', fontSize: '28px', fontWeight: '600', lineHeight: '42px', color: '#4B4F55' }}>Пароль успешно изменен!</Text>
				<Text style={{ margin: 0, textAlign: 'center', fontSize: '16px', fontWeight: '500', lineHeight: '24px', color: '#4B4F55' }}>Мы направим вас на страницу входа</Text>
				<Button
					type="primary"

					style={{
						width: "192px",
						borderRadius: 4,
						fontSize: 14,
						background: '#2E496F'
					}}
					onClick={() => dispatch(logout())}
				>
					Войти с новым паролем
				</Button>
			</div>

		</>

	)
}


export default SetPasswordSuccess;
